

export class CostReviewVfds {
  numberOfVfds!: number;
  manufacturer!: string;
  drivers!: number;
  unitsFurnishedBy!: number;
  unitsInstalledBy!: number;
  unitsWiredBy!: number;
  isVfdsApplicable!: boolean;
}
